var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "28", height: "44", viewBox: "0 0 28 44" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "filter",
        { id: "id-20a", width: "268.8%", height: "184.4%", x: "-84.4%", y: "-42.2%", filterUnits: "objectBoundingBox" },
        React.createElement("feOffset", { dy: "1", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
        React.createElement("feGaussianBlur", { "in": "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "3" }),
        React.createElement("feColorMatrix", { "in": "shadowBlurOuter1", result: "shadowMatrixOuter1", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.295969203 0" }),
        React.createElement(
          "feMerge",
          null,
          React.createElement("feMergeNode", { "in": "shadowMatrixOuter1" }),
          React.createElement("feMergeNode", { "in": "SourceGraphic" })
        )
      )
    ),
    React.createElement("path", { fill: "#FFF", d: "M.37 2.341a1.456 1.456 0 0 1 0-1.94 1.194 1.194 0 0 1 1.786 0l13.474 14.63a1.456 1.456 0 0 1 0 1.939L2.156 31.598a1.194 1.194 0 0 1-1.786 0 1.456 1.456 0 0 1 0-1.94L12.95 16 .37 2.341z", filter: "url(#id-20a)", transform: "matrix(-1 0 0 1 22 5)" })
  );
});